import React, { Component } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import RequestStatus from '../containers/pages/RequestStatusPage.js'
import FullReplacement from '../containers/pages/UploadPage.js'
import NewRequest from '../containers/pages/UploadPage.js'
import AddOn from '../containers/pages/UploadPage.js'
import FixErrorsAndWarning from '../containers/pages/FixErrorsAndWarningPage.js'
import appConfig from '../resource/appConfig.js'
import NotFound from '../containers/pages/NotFound.js'


export default class Main extends Component {
  render() {
    const valSuccessWithErrors = appConfig.reqStatuses.validationSuccesswithErrors,
          valSuccessful = appConfig.reqStatuses.validationSuccessful,
          valFailed = appConfig.reqStatuses.validationFailed,
          fulfilled = appConfig.reqStatuses.fulfilled,
          fulfilledWithFailures = appConfig.reqStatuses.fulfilledWithFailures,
          timedOut = appConfig.reqStatuses.timedOut

    const requestsCountLimit = appConfig.requestsCountLimit

    const addOnCountLimit = appConfig.addOnLinkRecordsCountLimit
    const request = this.props.fDataItems
    const requestCount = this.props.requestCount

    return (
      <main id="main-content">
      <Router>
        <Switch>
          <Route exact path="/" render={(props) => <RequestStatus
                                                    apiAuthHeaders={this.props.apiAuthHeaders}
                                                    fDataItems={request}
                                                    requestCount={requestCount}
                                                    {...props} />} />

          <Route
            path='/newRequest'
            render = {
              props => (requestCount < requestsCountLimit && (!request || (request && (request.UPLOAD_TYPE === '4' || request.REQ_STATUS === fulfilled || request.REQ_STATUS === fulfilledWithFailures))) ?
                <NewRequest
                  apiAuthHeaders={this.props.apiAuthHeaders}
                  fDataItems={request}
                  UpdateType="1"
                  {...props}
                  orgNames={this.props.orgNames}
                  eligibleOrgIds={this.props.eligibleOrgIds}
                  orgAiCodes={this.props.orgAiCodes}
                /> :
                <RequestStatus
                  apiAuthHeaders={this.props.apiAuthHeaders}
                  fDataItems={request}
                  requestCount={requestCount}
                  {...props}
                />
              )
            }
          />

          <Route
            path='/fullReplacementPage'
            render = {
              props => (request && request.UPLOAD_TYPE !== '4' && (request.REQ_STATUS === valSuccessWithErrors || request.REQ_STATUS === valSuccessful || request.REQ_STATUS === valFailed || request.REQ_STATUS === timedOut) ?
                <FullReplacement
                  apiAuthHeaders={this.props.apiAuthHeaders}
                  fDataItems={request}
                  UpdateType="2"
                  {...props}
                  eligibleOrgIds={this.props.eligibleOrgIds}
                /> :
                <RequestStatus
                  apiAuthHeaders={this.props.apiAuthHeaders}
                  fDataItems={request}
                  requestCount={requestCount}
                  {...props}
                />
              )
            }
          />


          <Route
            path='/addOn'
            render = {
              props => (request && request.UPLOAD_TYPE !== '4' && request.RECORDS_COUNT <= addOnCountLimit && (request.REQ_STATUS === valSuccessWithErrors || request.REQ_STATUS === valSuccessful || request.REQ_STATUS === valFailed) ?
                <AddOn
                  apiAuthHeaders={this.props.apiAuthHeaders}
                  fDataItems={request}
                  cogId={this.props.cogId}
                  coordinator={this.props.coordinator}
                  UpdateType="3"
                  {...props}
                  eligibleOrgIds={this.props.eligibleOrgIds}
                /> :
                <RequestStatus
                  apiAuthHeaders={this.props.apiAuthHeaders}
                  fDataItems={request}
                  requestCount={requestCount}
                  {...props}
                />
              )
            }
          />

          <Route
            path='/fixErrors'
            render = {
              props => (request && request.UPLOAD_TYPE !== '4' && ((request.REQ_STATUS === valSuccessWithErrors || request.REQ_STATUS === valFailed) && (request.ERROR_COUNT && request.ERROR_COUNT <= appConfig.erroneousRowsCountLimit)) ?
                <FixErrorsAndWarning
                  apiAuthHeaders={this.props.apiAuthHeaders}
                  fDataItems={request}
                  {...props}
                /> :
                <RequestStatus
                  apiAuthHeaders={this.props.apiAuthHeaders}
                  fDataItems={request}
                  requestCount={requestCount}
                  {...props}
                />
              )
            }
          />

          <Route component={NotFound} />


        </Switch>
        </Router>
      </main>
    )
  }
}
